<template>
    <div class="content">
        <h1>企业详情({{ dataForm.userType == 1 ? '个人' : '企业' }})</h1>
        <div class="top-info-box">
            <div style="flex:2"><span>昵称：</span><span>{{ dataForm.memberName }}</span></div>
            <div style="flex:2"><span>手机号：</span><span>{{ dataForm.phone }}</span></div>
            <div style="flex:1"><span>交易总额：</span><span>{{ dataForm.totalOrderAmount }}</span></div>
        </div>
        <div class="top-info-box">
            <div style="flex:2"><span>用户来源：</span><span>{{ dataForm.registerSource }}</span></div>
            <div style="flex:2"><span>邀请人：</span><span>{{ dataForm.parentName }}</span></div>
            <div style="flex:1"><span>邀请人手机号：</span><span>{{ dataForm.parentPhone }}</span></div>
        </div>
        <div class="top-info-box">
            <div style="flex:2"><span>可用积分：</span><span>{{ dataForm.score }}</span></div>
            <div style="flex:2"><span>可用余额：</span><span>{{ dataForm.balance }}</span></div>
            <div style="flex:1"><!-- <span>所属团长：</span><span></span> --></div>
        </div>
        <div class="top-info-box">
            <div><span>设置返佣比例：</span>
                <el-input v-model="dataForm.backRate" style="width: 200px;margin-left: 20px;" type="number" :min="0"
                    :max="100" @input="handleInput">
                    <template slot="suffix">
                        <span class="suffix">%</span>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="top-info-box">
            <div class="classify-box">
                <span>设置折扣比例：</span>
                <div class="classify-right">
                    <div v-for="(item, index) in dataForm.memberCommisionList" :key="item.id">
                        <span>{{ item.categoryName }}</span>
                        <el-input v-model="item.commissionRate" style="width: 100px;margin-left: 10px;" :min="0"
                            :max="100" type="number" @input="handleInput2($event, index)">
                            <template slot="suffix">
                                <span class="suffix">%</span>
                            </template></el-input>
                    </div>
                </div>

            </div>
        </div>
        <div class="top-card-box">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane v-if="dataForm.userType != 1" :label="dataForm.userType == 1 ? '个人认证信息' : '企业认证信息'"
                    name="first">
                    <div class="tab-info-box" v-if="dataForm.company">
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>企业名称：</span><el-input v-model="dataForm.company.enterpriseName"
                                    :disabled="true" />
                            </div>
                            <div class="box-item">
                                <span>统一代码：</span><el-input v-model="dataForm.company.enterpriseNo" :disabled="true" />
                            </div>

                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>法人姓名：</span>
                                <el-input v-model="dataForm.company.name" />
                            </div>
                            <div class="box-item">
                                <span>法人手机号：</span><el-input v-model="dataForm.company.phone" />
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>客户类型：</span>
                                <el-select v-model="dataForm.customType">
                                    <el-option label="新客户" value="1">
                                    </el-option>
                                    <el-option label="老客户" value="2">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="box-item">
                                <span>客户来源：</span><el-input v-model="dataForm.registerSource" />
                            </div>
                            <!-- <div class="box-item">
                                <span>行业类型：</span>
                                <el-select v-model="dataForm.isAuthCompany">
                                    <el-option label="未认证" value="0">
                                    </el-option>
                                    <el-option label="已认证" value="1">
                                    </el-option>
                                </el-select>
                            </div> -->
                        </div>

                        <div class="info-box-item">
                            <div class="box-item">
                                <span>证件类型：</span>
                                <el-input value="身份证" disabled />
                            </div>
                            <div class="box-item">
                                <span>证件号：</span><el-input v-model="dataForm.company.idCardNo" />
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>所在城市：</span>
                                <el-cascader v-model="cityValue" :options="options"
                                    @change="handleChange"></el-cascader>
                            </div>
                            <div class="box-item">
                                <span>人员规模：</span><el-input type="number" />
                            </div>
                        </div>

                        <div class="info-box-item">
                            <div class="box-item">
                                <span>授信额度：</span>
                                <el-input v-model="dataForm.company.totalQuota" />
                            </div>
                            <div class="box-item">
                                <span>经营地址：</span>
                                <el-input v-model="dataForm.company.address" />
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>主要经营内容：</span>
                                <el-input v-model="dataForm.company.mainBusinessContent"></el-input>
                            </div>
                            <div class="box-item">
                                <span>企业介绍：</span>
                                <el-input v-model="dataForm.company.enterpriseIntro"></el-input>
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span>企业类别：</span>
                                <el-select v-model="dataForm.company.enterpriseType" placeholder="请选择">
                                    <el-option label="农产品生产类" :value="1"></el-option>
                                    <el-option label="农产品加工类" :value="2"></el-option>
                                    <el-option label="农产品流通类" :value="3"></el-option>
                                    <el-option label="休闲农业类" :value="4"></el-option>
                                    <el-option label="农产品电商类" :value="5"></el-option>
                                    <el-option label="农业生产性服务类" :value="6"></el-option>
                                </el-select>
                            </div>
                            <div class="box-item">
                                <span>企业级别：</span>
                                <el-select v-model="dataForm.company.enterpriseLevel" placeholder="请选择">
                                    <el-option label="区级" :value="1"></el-option>
                                    <el-option label="市级" :value="2"></el-option>
                                    <el-option label="省级" :value="3"></el-option>
                                    <el-option label="国家级" :value="4"></el-option>
                                </el-select>
                            </div>

                        </div>
                        <div class="info-box-item">
                            <div class="box-item">
                                <span style="width: 220px;">是否为农业产业化重点龙头企业：</span>
                                <el-select v-model="dataForm.company.isAuthCompany">
                                    <el-option label="是" :value="1"></el-option>
                                    <el-option label="否" :value="2"></el-option>
                                </el-select>
                            </div>

                        </div>

                        <div class="info-box-item-img">
                            <span>身份证件照</span>
                            <div class="img-box">
                                <el-upload :action="$uploadURL" :show-file-list="false" :on-success="idCardSuccess"
                                    :on-preview="handlePictureCardPreview" :on-remove="removeIdCard">
                                    <img class="upload-idcard" v-if="dataForm.company.idCardFront"
                                        :src="dataForm.company.idCardFront">
                                    <img class="upload-idcard" v-else src="@/assets/images/idcard.png"
                                        mode="widthFix"></img>
                                </el-upload>
                                <el-upload style="margin-left: 80px;" :action="$uploadURL" :show-file-list="false"
                                    :on-success="idCardBackSuccess" :on-preview="handlePictureCardPreview"
                                    :on-remove="removeIdCardBack">
                                    <img class="upload-idcard" v-if="dataForm.company.idCardBack"
                                        :src="dataForm.company.idCardBack">
                                    <img class="upload-idcard" v-else src="@/assets/images/idcardback.png"
                                        mode="widthFix"></img>
                                </el-upload>
                            </div>
                        </div>
                        <div class="info-box-item-img">
                            <span>企业公司照</span>
                            <div class="img-box">
                                <el-upload :action="$uploadURL" :show-file-list="false" :on-success="mtSuccess"
                                    :on-preview="handlePictureCardPreview" :on-remove="removeMtImg">
                                    <img class="upload-img" v-if="dataForm.company.mtImg" :src="dataForm.company.mtImg">
                                    <div v-else class="avatar-uploader-icon" style="font-size: 18px;">门头照</div>
                                </el-upload>
                                <el-upload style="margin: 0 40px;" :action="$uploadURL" :show-file-list="false"
                                    :on-success="hjSuccess" :on-preview="handlePictureCardPreview"
                                    :on-remove="removeHjImg">
                                    <img class="upload-img" v-if="dataForm.company.hjImg" :src="dataForm.company.hjImg">
                                    <div v-else class="avatar-uploader-icon" style="font-size: 18px;">环境照</div>
                                </el-upload>
                                <el-upload :action="$uploadURL" :show-file-list="false" :on-success="cwgSuccess"
                                    :on-preview="handlePictureCardPreview" :on-remove="removeCwgImg">
                                    <img class="upload-img" v-if="dataForm.company.cwgImg"
                                        :src="dataForm.company.cwgImg">
                                    <div v-else class="avatar-uploader-icon" style="font-size: 18px;">储物柜照</div>
                                </el-upload>
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="info-box-item-img">
                                <span>营业执照</span><!-- businessLicenseImg -->
                                <div class="img-box">
                                    <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false"
                                        :on-success="licenseSuccess" :on-preview="handlePictureCardPreview"
                                        :on-remove="removeLicense">
                                        <img class="upload-img" v-if="dataForm.company.businessLicenseImg"
                                            :src="dataForm.company.businessLicenseImg">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="info-box-item-img">
                                <span>第三方检测报告</span>
                                <div class="img-box">
                                    <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false"
                                        :on-success="handleThirdPartySuccess" :on-preview="handlePictureCardPreview"
                                        :on-remove="removeLicense">
                                        <img class="upload-img" v-if="dataForm.company.thirdPartyImg"
                                            :src="dataForm.company.thirdPartyImg">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="info-box-item-img">
                                <span>资质许可证</span>
                                <div class="img-box">
                                    <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false"
                                        :on-success="handlePermitLicenseSuccess" :on-preview="handlePictureCardPreview"
                                        :on-remove="removeLicense">
                                        <img class="upload-img" v-if="dataForm.company.permitLicenseImg"
                                            :src="dataForm.company.permitLicenseImg">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div class="info-box-item">
                            <div class="info-box-item-img">
                                <span>荣誉证书</span>
                                <div class="img-box">
                                    <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false"
                                        :on-success="handleHonorLicenseSuccess" :on-preview="handlePictureCardPreview"
                                        :on-remove="removeLicense">
                                        <img class="upload-img" v-if="dataForm.company.honorLicenseImg"
                                            :src="dataForm.company.honorLicenseImg">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="info-box-item-img">
                                <span>专利证书</span>
                                <div class="img-box">
                                    <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false"
                                        :on-success="handlePatentLicenseSuccess" :on-preview="handlePictureCardPreview"
                                        :on-remove="removeLicense">
                                        <img class="upload-img" v-if="dataForm.company.patentLicenseImg"
                                            :src="dataForm.company.patentLicenseImg">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="info-box-item-img">

                            </div>
                        </div>
                    </div>

                </el-tab-pane>
                <el-tab-pane label="钱包明细信息" name="second">

                </el-tab-pane>
                <el-tab-pane label="邀请人明细" name="third">

                </el-tab-pane>
                <el-tab-pane label="消费账单信息" name="fourth">

                </el-tab-pane>
                <el-tab-pane label="提现信息" name="fifth">

                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="tab-card-box" v-if="activeName != 'first'">
            <el-date-picker v-if="activeName != 'third'" value-format="yyyy-MM" v-model="dateTime" type="month"
                placeholder="选择日期" @change="changeDate">
            </el-date-picker>
            <el-table fit :data="tableData" border style="width: 90%;" max-height="550" :header-cell-style="{
                'background-color': '#E6F4FF',
                'text-align': 'center',
                'border': '1px solid #e6e6e6'
            }">
                <el-table-column align="center" v-for="header in tableHeaders" :key="header.prop" :prop="header.prop"
                    :label="header.label">
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.page" :page-size="queryInfo.size" layout="total, prev, pager, next"
                :total="totle" class="ml10" style="margin-bottom: 15px"></el-pagination>
        </div>
        <div class="btn-box">
            <el-button @click="handelClose">取消</el-button>
            <el-button type="primary" @click="handleSave">确认</el-button>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
export default {
  name: '',
  props: {

  },
  data () {
    return {
      dataForm: {},
      activeName: 'first',
      dateTime: null,
      memberCode: '',
      tableData: [

      ],
      tableHeaders: [
        {
          prop: 'type',
          label: '交易方式'
        },
        {
          prop: 'createTime',
          label: '交易时间'
        },
        {
          prop: 'useAmount',
          label: '交易金额'
        }
      ],
      url: '/memberBalanceUseRecords/list',
      queryInfo: {
        condition: {},
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 10
      },
      totle: 0,
      options: regionData,
      cityValue: [],
      dialogImageUrl: '',
      dialogVisible: false

    }
  },
  // watch: {
  //     dateTime(val) {
  //         this.getTabbleData();
  //     },
  //     memberCode(val) {
  //         this.getInfo();
  //     }
  // },
  // mounted() {
  //     this.getInfo();
  // },
  methods: {

    init (val) {
      this.memberCode = val
      this.queryInfo.condition.memberCode = val
      this.getTabbleData()
      this.getInfo()
    },

    changeDate () {
      // this.queryInfo.condition.dateTime = this.dateTime;
      this.getTabbleData()
    },

    handleInput (value) {
      if (value < 0) {
        this.dataForm.backRate = 0
      }
      if (value > 100) {
        this.dataForm.backRate = 100
      }
    },
    handleInput2 (value, index) {
      let item = this.dataForm.memberCommisionList[index]
      if (value < 0) {
        item.commissionRate = 0
      }
      if (value > 100) {
        item.commissionRate = 100
      }
      this.$set(this.dataForm.memberCommisionList, index, item)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 身份证
    removeIdCardBack (file, fileList) {

    },
    removeIdCard (file, fileList) {
      console.log(file, fileList)
    },
    async idCardSuccess (e, file) {
      let url = file.response.data.url
      let res = await this.$http.post('/ocr/sfzOcr', {
        'url': url
      })
      if (res.data.code == 200) {
        this.dataForm.company.idCardFront = url
      } else {
        this.$message.error(res.data.message)
      }
    },
    async idCardBackSuccess (e, file) {
      let url = file.response.data.url
      let res = await this.$http.post('/ocr/sfzOcr', {
        'url': url
      })
      if (res.data.code == 200) {
        this.dataForm.company.idCardBack = url
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 门头照
    mtSuccess (res, file) {
      this.dataForm.company.mtImg = file.response.data.url
    },
    removeMtImg (file, fileList) {
      console.log(file, fileList)
    },
    // 环境照
    hjSuccess (res, file) {
      this.dataForm.company.hjImg = file.response.data.url
    },
    removeHjImg (file, fileList) {
      console.log(file, fileList)
    },
    // 储物柜照
    cwgSuccess (res, file) {
      this.dataForm.company.cwgImg = file.response.data.url
    },
    removeCwgImg (file, fileList) {
      console.log(file, fileList)
    },
    // 营业执照
    async licenseSuccess (e, file) {
      // this.dataForm.company.businessLicenseImg = file.response.data.url;
      let url = file.response.data.url
      let res = await this.$http.post('/ocr/businessLicenseOcr', {
        url
      })
      if (res.data.code == 200) {
        const info = JSON.parse(res.data.data.body.data).data
        this.dataForm.company.businessLicenseImg = url
        this.dataForm.company.enterpriseName = info.companyName
        this.dataForm.company.enterpriseNo = info.creditCode
        this.dataForm.company.address = info.businessAddress
        this.dataForm.company.mainBusinessContent = info.businessScope
        this.dataForm.company.name = info.legalPerson
      } else {
        this.$message.error(res.data.message)
      }
    },
    handlePermitLicenseSuccess (res, file) {
      this.dataForm.company.permitLicenseImg = file.response.data.url
    },
    handleThirdPartySuccess (res, file) {
      this.dataForm.company.thirdPartyImg = file.response.data.url
    },
    handleHonorLicenseSuccess (res, file) {
      this.dataForm.company.honorLicenseImg = file.response.data.url
    },
    handlePatentLicenseSuccess (res, file) {
      this.dataForm.company.patentLicenseImg = file.response.data.url
    },
    removeLicense (file, fileList) {
      console.log(file, fileList)
    },
    // 城市选择
    handleChange (value) {
      console.log(value)
    },
    async getInfo () {
      let res = await this.$http.post('/member/queryDetail', { memberCode: this.memberCode })
      if (res.data.code == 200) {
        this.dataForm = res.data.data

        if (this.dataForm.userType === '1') {
          this.activeName = 'second'
          this.handleTabClick({ name: 'second' })
        } else {
          this.activeName = 'first'
          this.handleTabClick({ name: 'first' })
          /* let company = {
                        enterpriseName: '',
                        enterpriseNo: '',
                        name: '',
                        phone: '',
                        idCardNo: '',
                        totalQuota: '',
                        address: '',
                        mainBusinessContent: '',
                        enterpriseIntro: '',
                        enterpriseType: '',
                        enterpriseLevel: '',
                        isAuthCompany: '',
                        idCardFront: '',
                        idCardBack: '',
                        mtImg: '',
                        hjImg: '',
                        cwgImg: '',
                        businessLicenseImg: '',
                        permitLicenseImg: '',
                        thirdPartyImg: '',
                        honorLicenseImg: '',
                        patentLicenseImg: ''
                    }
                    if (!this.dataForm.company) {
                        this.dataForm.company = company
                    } */
        }
        this.getTabbleData()
      }
    },
    handelClose () {
      this.$emit('close')
    },
    handleSave () {
      var that = this
      that.$http.post('/member/updateInfo', that.dataForm).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          that.$emit('close')
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
      }).catch(function (error) {

      })
    },
    // 监听 每页条数改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryInfo.currPage = newSize
      this.getTabbleData()
    },
    handleTabClick (tab, event) {
      this.dateTime = null
      this.queryInfo.currPage = 1
      this.tableData = []
      switch (tab.name) {
        case 'first':
          // 渲染企业信息
          break
        case 'second':
          this.tableHeaders = [
            {
              prop: 'type',
              label: '交易类型'
            },
            {
              prop: 'createTime',
              label: '交易时间'
            },
            {
              prop: 'useAmount',
              label: '交易金额'
            }
          ]
          this.url = '/memberBalanceUseRecords/list'
          this.getTabbleData()
          break
        case 'third':
          this.tableHeaders = [
            {
              prop: 'memberName',
              label: '邀请人姓名'
            },
            {
              prop: 'phone',
              label: '邀请人手机号'
            },
            {
              prop: 'createDate',
              label: '邀请人时间'
            }
          ]
          this.url = '/member/list'
          this.getTabbleData()
          break
        case 'fourth':
          this.tableHeaders = [
            {
              prop: 'orderNumber',
              label: '订单ID'
            },
            {
              prop: 'recipientName',
              label: '收货人'
            },
            {
              prop: 'productNames',
              label: '商品数量'
            },
            {
              prop: 'actualAmount',
              label: '实付金额'
            },
            {
              prop: 'orderTime',
              label: '交易完成时间'
            }
          ]
          this.url = '/order/list'
          this.getTabbleData()
          break
        case 'fifth':
          this.tableHeaders = [
            {
              prop: 'createTime',
              label: '提现时间'
            },
            {
              prop: 'balance',
              label: '提现金额'
            },
            {
              prop: 'bankCardNo',
              label: '提现到账银行卡'
            },
            {
              prop: 'examineStatus',
              label: '审核状态'
            },
            {
              prop: 'examineTime',
              label: '提现审核通过日期'
            }
          ]
          this.url = '/withdrawalRecords/list'
          this.getTabbleData()
          break
        default:
          break
      }
    },
    getTabbleData () {
      this.tableData = []
      this.total = 0
      this.queryInfo.condition.dateTime = this.dateTime
      if (this.activeName === 'third') {
        this.queryInfo.condition.parentCode = this.memberCode
      }
      if (this.activeName === 'fourth') {
        // this.queryInfo.condition.memberCode = this.memberCode
        this.queryInfo.condition.payStatus = 1
      }
      let that = this
      this.$http.post(this.url, this.queryInfo).then(res => {
        if (res.data.code == 200) {
          that.totle = res.data.data.count
          that.tableData = res.data.data.data
          if (that.activeName === 'second') {
            that.tableData = that.tableData.map(item => {
              if (item.type == 0) {
                item.type = '商城购物'
              } else if (item.type == 1) {
                item.type = '充值'
              }
              return item
            })
          }
          if (that.activeName === 'fifth') {
            that.tableData.forEach(item => {
              if (item.examineStatus == 0) {
                item.examineStatus = '待审核'
              } else if (item.examineStatus == 1) {
                item.examineStatus = '通过'
              } else if (item.examineStatus == 2) {
                item.examineStatus = '不通过'
              }
            })
          }
          if (this.activeName === 'second') {
            that.tableData.forEach(item => {
              if (item.type == 0) {
                item.type = '商城购物'
              } else if (item.type == 1) {
                item.type = '充值'
              }
            })
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content {
    padding: 0 20px;
    padding-bottom: 100px;
}

.top-info-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;

    div {
        span {
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            text-align: left;
            font-family: Arial-bold;
            font-weight: bold;
        }

        span:nth-child(2) {
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-family: Arial-regular;
            font-weight: normal;
        }
    }

    .classify-box {
        display: flex;

        .classify-right {
            margin-bottom: 20px;
            margin-left: 20px;
            flex: 1;
            display: flex;
            flex-wrap: wrap;

            div {
                display: flex;
                align-items: center;
                margin-right: 10px;
                margin-bottom: 10px;
                // width: 18%;

                span {
                    color: rgba(51, 51, 51, 1);
                    font-size: 14px;
                    text-align: left;
                    font-family: Arial-bold;
                    margin-bottom: 10px;
                }
            }

        }
    }
}

.top-card-box {
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;

    span {
        margin-right: 20px;
        font-size: 14px;
    }

    /deep/ .el-tabs {
        width: 80%;
    }
}

.tab-card-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 10px 20px;

}

.btn-box {
    display: flex;
    align-items: center;
    position: absolute;
    right: 40px;
    bottom: 40px;
}

.tab-info-box {
    margin: 20px;
    width: 95%;

    .info-box-item {
        display: flex;
        align-items: center;
        margin-top: 10px;
        justify-content: space-between;

        .box-item {
            display: flex;
            align-items: center;

            /deep/ .el-input {
                width: 200px;
            }

            span {
                width: 100px;
            }
        }

    }

    .info-box-item-img {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        flex: 1;

        .img-box {
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin-left: 100px;

            /deep/ .el-image {
                margin-left: 20px;
            }

            .upload-idcard {
                width: 240px;
                height: 146px;
            }

            .upload-img {
                width: 146px;
                height: 146px;
            }

            .avatar-uploader .el-upload {
                cursor: pointer;
                position: relative;
                overflow: hidden;
                align-items: center;
            }

            .avatar-uploader-icon {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                font-size: 28px;
                color: #8c939d;
                width: 146px;
                height: 146px;
                line-height: 146px;
                text-align: center;
            }
        }
    }
}

.suffix {
    font-size: 12px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: -10px;
    color: #606266;
}
</style>
